export default {"src":"/_next/static/media/option1bot.f5936f31.svg","height":221,"width":359,"blurWidth":0,"blurHeight":0};